import { useMemo } from 'react';

import classnames from 'classnames';
import i18next from 'i18next';
import { useHistory } from 'react-router';

import { isAuthenticated } from 'actions/user';
import { postMessageToMobileApp } from 'components/app/helpers';
import PopoverBaseCTA from 'components/popover/popover_base_cta';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import { IS_HYBRID_APP_SUPPORTED } from 'constants/rnApp';
import routes from 'constants/routes';
import { useRekycVerificationNavigation } from 'hooks/componentHooks/useRekycVerificationNavigation';
import useTotalAccountEquity from 'hooks/componentHooks/useTotalAccountEquity';
import useKYC from 'hooks/useKYC';
import useTradeTabMobile from 'hooks/useTradeTabMobile';
import { useAppSelector } from 'storeHooks';

import styles from './SubmitButton.module.scss';

const VerifyButton = () => {
  const { isLoggedIn } = useAppSelector(state => ({
    isLoggedIn: isAuthenticated(state.user),
  }));
  const history = useHistory();
  // TODO: useKYC will be converted to selectors soon
  const { isVerified, isUserIndian } = useKYC();
  const { navigateToVerification } = useRekycVerificationNavigation('Place Order');
  const isTradeTabMobile = useTradeTabMobile();
  const totalBalance = useTotalAccountEquity({});

  const handleOnClick = () => {
    if (!isLoggedIn) {
      if (IS_HYBRID_APP_SUPPORTED) {
        postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.LOGIN_CLICKED, {
          customRoute: '/charts',
          path: history.location.pathname,
        });
      } else {
        history.push(routes.login);
      }
    }
    if (!isVerified) {
      return navigateToVerification();
    }
    if (!totalBalance) {
      const route =
        isUserIndian && IS_INDIAN_EXCHANGE
          ? routes.account.deposit
          : routes.account.buy_crypto;
      return history.push(route);
    }
    return null;
  };

  const getCtaText = useMemo(() => {
    if (!isLoggedIn) return i18next.t('trading:loginToTrade');
    if (!isVerified) return i18next.t('trading:getVerifiedToTrade');
    return IS_INDIAN_EXCHANGE
      ? i18next.t('trading:addFundsToTrade')
      : i18next.t('trading:depositToTrade');
  }, [isLoggedIn, isVerified]);

  return (
    (<div className={styles.verifyContainer} data-palette="VerifyButton">
      <PopoverBaseCTA
        disabled={isVerified}
        wrapperClass={classnames('verify-button', styles.iconWrapper)}
        popoverOptions={{
          body: i18next.t('trading:placeOrderPopover'),
          shouldEnableClickListener: true,
        }}
        hideIcon={isTradeTabMobile && !isLoggedIn}
      >
        <button
          data-testid="market-place-order-btn"
          className={classnames(
            'naked btn font-fontRegular mt-3 font-size-sm4 w-100 pointer placeorder-button verify-button',
            styles.submitButton,
            styles.primaryButton,
            styles.verifyButton,
            {
              'inTradeTabMobile_verify-button':
                isTradeTabMobile && isLoggedIn && !isVerified,
            }
          )}
          onClick={handleOnClick}
          type="button"
        >
          {getCtaText}
        </button>
      </PopoverBaseCTA>
    </div>)
  );
};

export default VerifyButton;
